export default __webpack_public_path__ + "static/media/tablet-page-top.51424655.jpg";